import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {RouterModule, Routes} from '@angular/router';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatAutocompleteModule, MatInputModule} from '@angular/material';
import {BlockUIModule} from 'ng-block-ui';
import {SafePipeModule} from 'safe-pipe';
import {NgxExtendedPdfViewerModule} from 'ngx-extended-pdf-viewer';
import {CustomHttpInterceptor} from "./interceptors/custom-http-interceptor";
import {MatchHeightDirective} from './directives/match-height.directive';

import {AppComponent} from './app.component';
import {ViewQuotesComponent} from './components/view-quotes/view-quotes.component';
import {GlobalService} from './api/services/global/global.service';
import {ViewQuoteDetailsComponent} from './components/view-quote-details/view-quote-details.component';
import {CreateQuoteComponent} from './components/create-quote/create-quote.component';
import {ViewPremiumComponent} from './components/view-premium/view-premium.component';
import {ClientValidateIdComponent} from './components/client-validate-id/client-validate-id.component';
import {ContentComponent} from './components/content/content.component';
import {TermsConditionsComponent} from './components/terms-conditions/terms-conditions.component';
import {DisplayQuoteComponent} from './components/display-quote/display-quote.component';

const routes: Routes = [
  { path: '', redirectTo: 'view-quotes', pathMatch: 'full' },
  { path: 'view-quotes',
    children: [
      { path: '', component: ViewQuotesComponent },
      { path: ':id', component: ViewQuoteDetailsComponent }
    ]
  },
  { path: 'create-quote', component: CreateQuoteComponent },
  { path: 'view-premium', component: ViewPremiumComponent },
  { path: 'client-quote', component: ClientValidateIdComponent },
  { path: 'terms-conditions', component: TermsConditionsComponent },
  { path: 'display-quote', component: DisplayQuoteComponent },
];

@NgModule({
  declarations: [
    AppComponent,
    ViewQuotesComponent,
    ViewQuoteDetailsComponent,
    CreateQuoteComponent,
    ViewPremiumComponent,
    ClientValidateIdComponent,
    TermsConditionsComponent,
    DisplayQuoteComponent,
    ContentComponent,
    MatchHeightDirective
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(routes, {useHash: true}),
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatInputModule,
    BlockUIModule.forRoot(),
    SafePipeModule,
    NgxExtendedPdfViewerModule,
  ],
  providers: [
    GlobalService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomHttpInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }
